import { render } from "./FoodRunnerModal.vue?vue&type=template&id=77d70224&scoped=true"
import script from "./FoodRunnerModal.vue?vue&type=script&lang=js"
export * from "./FoodRunnerModal.vue?vue&type=script&lang=js"

import "./FoodRunnerModal.vue?vue&type=style&index=0&id=77d70224&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d70224"]])

export default __exports__